import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet-view_open",
  "use": "icon-sheet-view_open-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-sheet-view_open\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.485 2L6.243 5.738 2 2\" /><path d=\"M10.485 5.524L6.243 9.262 2 5.524\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol